/**
 * Runtime-resolved config.
 *
 * The web container's entrypoint writes /env.js at startup using the
 * Railway-injected env vars. That makes the bundle Railway-macro-aware
 * without baking URLs in at build time (Vite env vars are inlined at
 * build, and Railway macros only resolve at deploy time).
 *
 * Priority: window.__MEMKERNEL_CONFIG__ → import.meta.env → "".
 */

declare global {
  interface Window {
    __MEMKERNEL_CONFIG__?: {
      apiBaseUrl?: string;
    };
  }
}

export function apiBaseUrl(): string {
  const runtime =
    typeof window !== "undefined" ? window.__MEMKERNEL_CONFIG__?.apiBaseUrl : undefined;
  if (runtime) return runtime.replace(/\/+$/, "");
  const build = import.meta.env.VITE_API_BASE_URL;
  if (build) return build.replace(/\/+$/, "");
  return "";
}
